import { useTheme } from '@mui/material/styles'
import { getAuth } from 'firebase/auth'
import { Link } from 'react-router-dom'
import { Avatar, List, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material'
import * as React from 'react'
import getInitials from '../../utils/GetInitials/GetInitials'
import { avatarContainerStyle, avatarStyle, displayedDetailStyle, listItemButtonStyle } from './UserProfileCard.styles'

type UserProfileCardProps = {
	sidebarOpen: boolean
}

export default function UserProfileCard({ sidebarOpen }: UserProfileCardProps) {
	const theme = useTheme()
	const auth = getAuth()
	const user = auth.currentUser

	return (
		<List component="nav">
			<ListItemButton key="/settings" component={Link} to="/settings" sx={listItemButtonStyle}>
				<ListItemAvatar sx={avatarContainerStyle}>
					<Avatar sx={avatarStyle}>{user && user.displayName ? getInitials(user.displayName) : 'U'}</Avatar>
				</ListItemAvatar>
				{sidebarOpen && (
					<React.Fragment>
						<ListItemText primary={user?.displayName} secondary={user?.email} sx={displayedDetailStyle} />
					</React.Fragment>
				)}
			</ListItemButton>
		</List>
	)
}
